<template>
    <div class="window bg">
        <div class="container">
            <!--background black-->
            <div class="container-black-bg">
            </div>
            <!-- end background black-->

            <loading class="progress" v-if="isRecording" is-short="true" v-on:onRecordDone="handleRecordDone"></loading>

            <counter v-if="counterStart" v-on:onRecord="handleRecordStart"></counter>

            <div class="img-container">
                <img v-bind:src="getCharacter.fullImage" class="img-container_img">
                <character-talk v-bind:text="getPracticeText[1].text" v-if="isRecording" v-bind:is-blue="true" v-bind:show-name="false" ></character-talk>
            </div>
            <button v-if="showStop" class="btn-stop" @click="handleRecordDone">Stop</button>

        </div>
    </div>
</template>

<script>
    import {mapGetters , mapMutations} from "vuex";
    import MenuOption from "../components/MenuOption";
    import Counter from "../components/Counter";
    import Loading from "../components/Loading";
    import CharacterTalk from "../components/CharacterTalk";
    import RecordMixin from "../mixins/RecordMixin";
    import anime from 'animejs';


    export default {
        name: "PracticeStart",
        components: {
            MenuOption,
            Counter,
            Loading,
            CharacterTalk
        },
        mixins: [RecordMixin],
        computed: {
            ...mapGetters(["getCharacter", "getPracticeText"])
        },
        methods: {
            ...mapMutations(['setMode']),
            start() {
                this.counterStart = true;
                this.showCharacter = false;
                this.showStart = false;
            },
            handleRecordDone() {
                this.recordDone();
                this.setMode('practice')
                this.$router.push('/result');
            },
            handleRecordStart() {
                this.record();
                this.showCharacter = true;
                this.counterStart = false;
            },
            goBack() {
                if (this.isRecording) {
                    this.cancelRecord();
                }
                this.$router.push("/menu");
            },
            enterAnim(el, done) {
                const ani = anime({
                    targets: el,
                    opacity: [0, 1],
                    easing: 'easeInQuad'
                })
            }
        },
        data() {
            return {
                recordStart: false,
                counterStart: false,
                showCharacter: true,
                showStart: true,
                showStop: false
            };
        },
        mounted() {
            this.start();
            setTimeout(()=>{
                this.showStop = true;
            }, 10000)
        }
    };
</script>

<style scoped>

</style>
